import firebase from "firebase/app";
import "firebase/firestore";
const firebaseConfig = {
    apiKey: "AIzaSyC2WPVb6q-IQB72M_i90wckdINGn5sJQ5g",
    authDomain: "summer-iser.firebaseapp.com",
    databaseURL: "https://summer-iser.firebaseio.com",
    projectId: "summer-iser",
    storageBucket: "summer-iser.appspot.com",
    messagingSenderId: "439557640608",
    appId: "1:439557640608:web:a771700645c523d22a54c5",
    measurementId: "G-ZT4LEJJ3PK",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
